module.exports = __webpack_public_path__ + "static/media/dgtl.8d92a3de.png";